export default __webpack_public_path__ + "static/media/backyard-burger.db066d40.png";